<template>
  <div class="div">
    <img src="@/assets/404.png" alt="error 404" class="div__img">
  </div>
</template>

<script >
export default {
  name: 'ErrorView',
}
</script>

<style  lang=scss scoped>



.div__img {
margin-left: 36vw;
}
</style>